export class Country {
  name: string;
  code: string;
}
